import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/global.css'
import { applyRouteSeo } from './utils/seo'
import { getActiveLocale } from './i18n/useLocale'

//createApp(App).mount('#app')
const app = createApp(App)

app.use(router)

router.isReady().then(() => {
	applyRouteSeo(router.currentRoute.value, getActiveLocale())
})

app.mount('#app')
